
    export default {
        name: 'ShareProfile',
        props: {
            share: Object
        },
    }
